<template>
  <FourElement />
  <div class="collection-container">
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <SideBar v-if="siteBarVisible" />
  <CoverList />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import FourElement from './components/FourElement'
import SideBar from './components/SideBar'
import List from './components/List'
import CoverList from './components/CoverList'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
const {
  common_querySiteInfo_get_,
  newSize_getTypes_post_copy_v2,
  buyitwith_list_post_,
  buyitwith_save_post_,
  buyitwith_page_post_,
  buyitwith_modify_post_,
  buyitwith_delete_id_get_,
  buyitwith_query_id_get_
} = useAPI(null, [3426, 4240, 5922, 13768, 4243])
export default {
  components: {
    FourElement,
    SideBar,
    List,
    CoverList
  },
  setup() {
    const state = reactive({
      //筛选条件
      searchParams: {
        terminalIds: [1],
        siteIds: [1],
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        themeType: 2,
        categoryInfo: [[214, 228]]
      },

      sites: [],
      monthOptions: [
        {
          value: 1,
          label: '1月'
        },
        {
          value: 2,
          label: '2月'
        },
        {
          value: 3,
          label: '3月'
        },
        {
          value: 4,
          label: '4月'
        },
        {
          value: 5,
          label: '5月'
        },
        {
          value: 6,
          label: '6月'
        },
        {
          value: 7,
          label: '7月'
        },
        {
          value: 8,
          label: '8月'
        },
        {
          value: 9,
          label: '9月'
        },
        {
          value: 10,
          label: '10月'
        },
        {
          value: 11,
          label: '11月'
        },
        {
          value: 12,
          label: '12月'
        }
      ],

      cascaderOptions: [],
      cascaderOptionsv2: [],

      fieldNames: {
        label: 'typeName',
        value: 'categoryId',
        children: 'nextLevelList'
      },

      getTypes: () => {
        newSize_getTypes_post_copy_v2(
          { brandId: 1, channelId: 1, siteId: 1, terminalId: 1 },
          state
        )
      },

      coverDataSource: [],
      coverVisible: false,

      repeatTest: () => {
        let params = {
          ...state.postParams,
          themeType: state.searchParams.themeType,
          categoryInfos: state.postParams.categoryInfos.map(item => ({
            firstCategoryInfo: {
              categoryId: item[0]
            },
            secondCategoryInfo: {
              categoryId: item[1]
            },
            thirdCategoryInfo: [
              {
                categoryId: item[2]
              }
            ]
          }))
        }

        if (!params.terminalIds.length) {
          return message.error('请选择终端')
        }

        if (!params.months.length) {
          return message.error('请选择月份')
        }

        if (!params.categoryInfos.length) {
          return message.error('请选择主商品三级类目')
        }

        buyitwith_list_post_(params, state)
      },

      categories1: [],
      categories2: [],
      categories3: [],
      categories4: [],
      categories5: [],

      save: () => {
        state.changeCoverVisible(false)
        let params = {
          ...state.postParams,
          themeType: state.searchParams.themeType,
          categoryInfos: state.postParams.categoryInfos.map(item => ({
            firstCategoryInfo: {
              categoryId: item[0]
            },
            secondCategoryInfo: {
              categoryId: item[1]
            },
            thirdCategoryInfo: [
              {
                categoryId: item[2]
              }
            ]
          })),
          details: [
            {
              categoryIdInfo: state.categories1.map(item => item.join(',')),
              position: 1
            },
            {
              categoryIdInfo: state.categories2.map(item => item.join(',')),
              position: 2
            },
            {
              categoryIdInfo: state.categories3.map(item => item.join(',')),
              position: 3
            },
            {
              categoryIdInfo: state.categories4.map(item => item.join(',')),
              position: 4
            },
            {
              categoryIdInfo: state.categories5.map(item => item.join(',')),
              position: 5
            }
          ]
        }

        buyitwith_save_post_(params, state)
      },

      modify: () => {
        let params = {
          id: state.record.id,
          details: [
            {
              categoryIdInfo: state.categories1.map(item => item.join(',')),
              position: 1
            },
            {
              categoryIdInfo: state.categories2.map(item => item.join(',')),
              position: 2
            },
            {
              categoryIdInfo: state.categories3.map(item => item.join(',')),
              position: 3
            },
            {
              categoryIdInfo: state.categories4.map(item => item.join(',')),
              position: 4
            },
            {
              categoryIdInfo: state.categories5.map(item => item.join(',')),
              position: 5
            }
          ]
        }
        buyitwith_modify_post_(params, state)
      },

      changeCoverVisible: (visible = false) => {
        state.coverVisible = visible
      },

      terminalOptions: [
        { value: 1, label: 'WEB' },
        { value: 2, label: 'APP' }
      ],

      siteBarVisible: false,
      record: null,
      edit: false,

      changeVisible: (visible = false, record = null) => {
        state.record = record
        state.edit = record ? true : false
        if (record) {
          buyitwith_query_id_get_({ id: record.id }, state)
        } else {
          state.siteBarVisible = visible
        }
        if (!visible) {
          state.postParams = {
            siteName: null,
            terminalName: null,
            month: null,
            siteIds: [], // 站点ID
            terminalIds: [], // 终端ID
            months: [], // 月份
            categoryInfos: [], // 主商品二级类目ID
            details: [] // 坑位列表
          }
          state.categories1 = []
          state.categories2 = []
          state.categories3 = []
          state.categories4 = []
          state.categories5 = []
        }
      },

      watchPage: e => {
        if (!e) return
        state.pagination.pageNum = e
        state.initList()
      },

      deleteFun: params => {
        const { id } = params
        buyitwith_delete_id_get_({ id }, state)
      },

      dataSource: [],

      postParams: {
        siteName: null,
        terminalName: null,
        month: null,
        siteIds: [], // 站点ID
        terminalIds: [], // 终端ID
        months: [], // 月份
        categoryInfos: [], // 主商品二级类目ID
        details: [] // 坑位列表
      },

      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },

      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },

      initList: () => {
        let params = { ...state.searchParams, ...state.pagination }
        const { categoryInfo } = state.searchParams
        params.categoryInfo = categoryInfo.map(item => ({
          secondCategoryInfo: {
            categoryId: item[item.length - 1]
          }
        }))
        buyitwith_page_post_(params, state)
      },

      init: () => {
        state.initList()
      }
    })
    onMounted(() => {
      common_querySiteInfo_get_(
        {
          state
        },
        state.init()
      )

      state.getTypes()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
